module.exports = __webpack_public_path__ + "src/assets/img/s-autostart.cc877d2f.svg";